<div class="violation-details-container bg-red-50 rounded-lg p-4 border border-red-200">
    <!-- Header -->
    <div class="flex items-center justify-between mb-4">
        <div class="flex items-center">
            <mat-icon class="text-red-600 mr-2">warning</mat-icon>
            <h3 class="text-lg font-semibold text-red-800">Violation Details</h3>
        </div>
        <div class="flex items-center gap-2">
            <jjames-badge [variant]="getStatusBadgeVariant()">
                {{ getStatusText() }}
            </jjames-badge>
            <button mat-icon-button (click)="onClose()" class="text-gray-500 hover:text-gray-700">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <!-- Summary -->
    <div class="grid grid-cols-2 gap-4 mb-4">
        <div class="bg-white rounded-lg p-3">
            <div class="flex items-center">
                <mat-icon class="text-red-500 mr-2">error_outline</mat-icon>
                <div>
                    <p class="text-xs text-gray-500">Total Violations</p>
                    <p class="text-xl font-bold text-red-700">{{ violationDetails.violationCount || 0 }}</p>
                </div>
            </div>
        </div>
        <div class="bg-white rounded-lg p-3">
            <div class="flex items-center">
                <mat-icon class="text-gray-500 mr-2">schedule</mat-icon>
                <div>
                    <p class="text-xs text-gray-500">Processed At</p>
                    <p class="text-sm font-medium text-gray-900">{{ formatDate(violationDetails.processedAt) }}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- Violation Items List -->
    @if (violationDetails.violationItems && violationDetails.violationItems.length > 0) {
    <div class="space-y-3">
        <h4 class="text-sm font-semibold text-gray-700">Violation Items</h4>
        @for (item of violationDetails.violationItems; track item.id) {
        <div class="bg-white rounded-lg p-3 border border-gray-200">
            <div class="flex items-start justify-between mb-2">
                <div class="flex items-center">
                    <mat-icon [class]="item.isActive ? 'text-red-500' : 'text-gray-400'" class="mr-2 text-base">
                        {{ item.isActive ? 'error' : 'check_circle' }}
                    </mat-icon>
                    <span class="font-medium text-gray-900">{{ item.violationType || 'Unknown Type' }}</span>
                </div>
                <jjames-badge [variant]="getViolationTypeBadgeVariant(item)">
                    {{ item.isActive ? 'Active' : 'Resolved' }}
                </jjames-badge>
            </div>

            @if (item.description) {
            <p class="text-sm text-gray-600 mb-2 ml-7">{{ item.description }}</p>
            }

            <div class="grid grid-cols-3 gap-2 text-xs ml-7">
                <div>
                    <span class="text-gray-500">Started:</span>
                    <span class="ml-1 font-medium">{{ formatDate(item.startedAt) }}</span>
                </div>
                <div>
                    <span class="text-gray-500">Ended:</span>
                    @if (item.endedAt) {
                    <span class="ml-1 font-medium">{{ formatDate(item.endedAt) }}</span>
                    } @else {
                    <span class="ml-1 font-medium text-red-600">Ongoing</span>
                    }
                </div>
                <div>
                    <span class="text-gray-500">Duration:</span>
                    <span class="ml-1 font-medium">{{ formatDuration(item.duration) }}</span>
                </div>
            </div>
        </div>
        }
    </div>
    } @else {
    <div class="text-center py-4 text-gray-500">
        <mat-icon class="text-gray-400 mb-2">info</mat-icon>
        <p class="text-sm">No violation items available</p>
    </div>
    }
</div>